exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-536831ba]{margin-bottom:0}[data-v-536831ba] .el-table .cell{word-break:normal}", ""]);

// exports
